function FieldLabel({ children, customClass = null }) {
    return <label className={customClass ? customClass : "flex w-full sm:text-[17px] sm:leading-[24px] text-[15px] leading-[17.5px] font-700 mb-4"}>
        {children}
    </label>
}

export default FieldLabel;